const { isUseCaseAvailable, useCaseRedirect, INITIAL_DATA_ID, serializeUseCaseInitialData } = require('../../shared/public/use-cases.cjs');

function readUseCaseInitialData(slug, doc = typeof document === 'undefined' ? null : document) {
  try {
    const payload = JSON.parse(doc?.getElementById(INITIAL_DATA_ID)?.textContent || 'null');
    if (payload?.useCase?.slug !== slug || !isUseCaseAvailable(payload.useCase) || useCaseRedirect(payload.useCase)) return null;
    return { useCase: payload.useCase, relatedUseCases: Array.isArray(payload.relatedUseCases) ? payload.relatedUseCases : [] };
  } catch { return null; }
}

function markUseCaseReady(slug) {
  if (typeof document !== 'undefined') document.documentElement.setAttribute('data-use-case-ready', slug);
}

module.exports = { INITIAL_DATA_ID, serializeUseCaseInitialData, readUseCaseInitialData, markUseCaseReady };
